exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-flex{display:flex;justify-content:space-between;align-items:center}.salesEdu-detail-statistic{padding:8px 12px;border-radius:4px}.salesEdu-detail-statistic__green{background-color:#DAFBE4}.salesEdu-detail-statistic__red{background-color:#FFF0F1}.filter__success .el-checkbox__label{color:#24a148 !important}.filter__failed .el-checkbox__label{color:#ed1c24 !important}\n", ""]);

// exports
